<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/pegawai-list-custom">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Pengajuan
        </li>
      </ol>
    </nav>

    <div class="content-block">
      <h5>Daftar Pengajuan</h5>
    </div>
    <LogPopupTemplate ref="logPopup" />

    <DxPopup
      :visible="loadingVisible"
      title="Loading data..."
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="300"
      :height="130"
    >
      <div class="d-flex justify-content-center">
        <div
          class="spinner-border"
          style="width: 3rem; height: 3rem"
          role="status"
        ></div>
      </div>
    </DxPopup>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          :focused-row-enabled="true"
          ref="dataGrid"
          :data-source="pengajuanListStore.dataSourcePengajuanList"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @exporting="onExporting"
          @editing-start="onEditingStart"
          @init-new-row="initNewRow($event)"
          @row-removing="onRowRemoving"
          @row-inserting="onInserting"
          @row-updating="onUpdating"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :remote-operations="true"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
          @context-menu-preparing="onContextMenuPreparing($event)"
          @editor-preparing="onEditorPreparing"
          @saved="onSaved"
        >
          <!-- :filter-value="filterValue"
        :filter-sync-enabled="true" -->
          <!-- @selection-changed="onSelectionChanged" -->
          <DxHeaderFilter :visible="true" />

          <DxScrolling mode="virtual" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxPager
            :visible="true"
            :showPageSizeSelector="false"
            :showNavigationButtons="false"
            :show-info="true"
            :infoText="'Page {0} of {1} ({2} items)'"
          />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" />
          <DxEditing
            :allow-updating="
              allowUpdate(can('pegawai-update'), can('gaji-approve'))
            "
            :allow-deleting="can('pegawai-del')"
            :allow-adding="can('pegawai-create')"
            :mode="dxEditingMode"
            v-bind="commonFunction.editingConfig(dxEditingMode, 'pengajuan')"
          />
          <!--  -->
          <DxSelection mode="multiple" :deferred="true" />
          <DxToolbar>
            <DxItem
              location="after"
              template="status-setujui-selection-template"
              v-if="can('pegawai-create')"
            />
            <DxItem
              location="after"
              template="status-tolak-selection-template"
              v-if="can('pegawai-create')"
            />
            <DxItem location="after" template="refresh-template" />
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('dataGrid')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <template #status-setujui-selection-template>
            <DxButton
              v-if="can('gaji-approve')"
              icon="check"
              @click="onSelectRowsConfirm(1)"
              text="Setujui Pilihan"
              type="success"
              style="float: left"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <template #status-tolak-selection-template>
            <DxButton
              v-if="can('gaji-approve')"
              icon="close"
              @click="onSelectRowsConfirm(2)"
              text="Tolak Pilihan"
              type="danger"
              style="float: left"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <DxColumnFixing :enabled="true" />
          <!-- cell-template="diff-cell-template" -->

          <DxColumn
            caption="#"
            data-field="row_number"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
            data-type="number"
          />

          <DxColumn
            data-field="status"
            caption="Status"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.statusPengajuanSource }"
            cell-template="templateStatus"
            :allow-editing="can('gaji-approve')"
            :fixed="true"
            fixed-position="left"
          >
            <DxRequiredRule />
            <DxLookup
              display-expr="nama"
              value-expr="val"
              :data-source="commonStore.statusPengajuanStore"
            />
          </DxColumn>

          <DxColumn
            dataField="jenis"
            caption="Jenis Pengajuan"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.jenisPengajuanSource }"
            :fixed="true"
            fixed-position="left"
            :allow-filtering="false"
            :allow-editing="can('pegawai-update')"
          >
            <DxRequiredRule />
            <DxLookup
              display-expr="nama"
              value-expr="val"
              :data-source="commonStore.jenisPengajuanStore"
            />
          </DxColumn>

          <DxColumn
            data-type="string"
            data-field="simpeg_pegawais_nik"
            caption="NIK"
            :fixed="true"
            fixed-position="left"
            :allowHeaderFiltering="false"
            :allow-editing="can('pegawai-update')"
          >
          </DxColumn>

          <dx-column
            data-field="id"
            caption="id"
            data-type="number"
            :visible="false"
          />
          <dx-column
            data-field="pegawai_id"
            caption="pegawai_id"
            data-type="number"
            :visible="false"
          />

          <!-- <dx-column
            data-field="pegawai_id"
            caption="Nama Pegawai"
            :visible="true"
            :allow-filtering="true"
            :allowHeaderFiltering="true"
            :allow-sorting="true"
            :header-filter="{
              dataSource: commonStore.getPegawaiSource(pegawaiSource).value,
            }"
            :fixed="true"
            fixed-position="left"
            :allow-editing="can('pegawai-update')"
            :min-width="200"
            :filterOperations="['contains', 'startswith']"
          >
            <DxRequiredRule />
            <DxLookup
              display-expr="nama"
              value-expr="id"
              :data-source="pegawaiSource"
              :allowClearing="true"
            />
          </dx-column> -->

          <dx-column
            data-field="simpeg_pegawais_nama"
            caption="Nama Pegawai"
            :visible="true"
            :allow-filtering="true"
            :allowHeaderFiltering="true"
            :allow-sorting="true"
            :header-filter="{
              dataSource: commonStore.getPegawaiSource(pegawaiSource).value,
            }"
            :fixed="true"
            fixed-position="left"
            :allow-editing="can('pegawai-update')"
            :min-width="200"
            :filterOperations="['contains', 'startswith']"
            edit-cell-template="editPegawaiTemplate"
          >
            <!-- cell-template="pegawaiTemplate"  -->
            <DxRequiredRule />
          </dx-column>
          <!-- <template #pegawaiTemplate="{ data }">{{
            data.data.simpeg_pegawais_nama
          }}</template> -->
          <template #editPegawaiTemplate="{ data: cellInfo }">
            <DxSelectBox
              ref="selectDxediting"
              :dataSource="pegawaiSource"
              valueExpr="id"
              displayExpr="nama"
              width="100%"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              :searchEnabled="true"
              :value="selectedPegawaiId"
              @valueChanged="handlePegawaiChange($event, cellInfo)"
            />
            <!-- @valueChanged="(e) => cellInfo.setValue(e.value)" -->
            <!-- :value="cellInfo.value" -->
          </template>

          <DxColumn
            data-field="tgl"
            caption="Tgl"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            :allowHeaderFiltering="false"
            :allow-editing="can('pegawai-update')"
          >
            <DxRequiredRule />
          </DxColumn>

          <DxColumn
            data-field="golongan_id"
            caption="Gol."
            :allowHeaderFiltering="true"
            :header-filter="{
              dataSource: commonStore.getGolonganSource('crud').value,
            }"
            :allow-editing="can('pegawai-update')"
          >
            <DxLookup
              display-expr="nama"
              value-expr="id"
              :data-source="golonganStore"
            />
          </DxColumn>

          <DxColumn
            data-field="jenis_naik_pangkat"
            caption="Naik Pangkat"
            :allowHeaderFiltering="true"
            :header-filter="{
              dataSource: commonStore.getTipeNaikPangkatSource('crud').value,
            }"
            :allow-editing="can('pegawai-update')"
          >
            <DxLookup
              display-expr="nama"
              value-expr="nama"
              :data-source="tipeNaikPangkatStore"
            />
          </DxColumn>

          <DxColumn
            :allow-editing="can('pegawai-update')"
            data-field="capeg"
            caption="Status Capeg"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.statusCapegSource }"
          >
            <DxLookup
              display-expr="nama"
              value-expr="val"
              :data-source="commonStore.statusCapegStore"
            />
          </DxColumn>

          <DxColumn
            data-field="masa_kerja"
            caption="Masa Kerja (Tahun)"
            :allowHeaderFiltering="false"
            data-type="number"
            :allow-editing="can('pegawai-update')"
            :editor-options="{ readOnly: false }"
            :customize-text="commonFunction.appendTahun"
          >
            <DxRequiredRule />
          </DxColumn>
          <DxColumn
            data-field="masa_kerja_bulan"
            caption="Masa Kerja (Bulan)"
            :allowHeaderFiltering="false"
            data-type="number"
            :allow-editing="can('pegawai-update')"
            :editor-options="{ readOnly: false }"
            :customize-text="commonFunction.appendBulan"
          >
            <DxRequiredRule />
          </DxColumn>
          <DxColumn
            data-field="gaji_pokok_skema_details_jml"
            caption="Gaji Pokok"
            :allowHeaderFiltering="false"
            data-type="number"
            :customize-text="commonFunction.formatNumberWithDots"
          ></DxColumn>

          <DxColumn
            data-field="ket"
            caption="Ket."
            :allowHeaderFiltering="false"
            :allow-editing="
              allowUpdate(can('pegawai-update'), can('gaji-approve'))
            "
          />

          <!-- <DxColumn
            caption="Diajukan oleh"
            :allowHeaderFiltering="false"
            :cell-template="commonFunction.templateCreatedByUser"
          /> -->

          <DxColumn
            :allowHeaderFiltering="false"
            :allow-filtering="false"
            :allow-sorting="true"
            :allow-exporting="false"
            :allow-editing="true"
            :allow-adding="true"
            cell-template="fileTemplate"
            caption="Dokumen"
            data-field="file_path"
            data-type="string"
            edit-cell-template="editFileTemplate"
          >
          </DxColumn>

          <template #editFileTemplate="{ data }">
            <div>
              <DxFileUploader
                ref="fileUploaderRef"
                accept="*"
                upload-mode="useForm"
                @value-changed="onFileValueChanged($event, { data })"
                @uploaded="onUploaded($event, { data })"
              />
            </div>
          </template>
          <template #fileTemplate="{ data }">
            <div class="small-button-container">
              <DxButton
                :visible="setPrintAdaFile(data.text)"
                @click="
                  commonFunction.handleClickDocument(
                    data,
                    data.data.simpeg_pegawais_nama + ' - File Pengajuan',
                  )
                "
                icon="download"
              />
            </div>
          </template>

          <DxColumn
            caption="Dibuat oleh"
            :allowHeaderFiltering="false"
            data-field="created_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <DxColumn
            caption="Diubah oleh"
            :allowHeaderFiltering="false"
            data-field="updated_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <DxColumn
            caption="Disetujui oleh"
            :allowHeaderFiltering="false"
            data-field="approved_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <template #templateStatus="{ data }">
            <StatusPengajuanTemplate :value="data.value" />
          </template>

          <!-- <template #templateCreatedBy="{ data }">
            {{ commonFunction.viewCreatedBy(data.data) }}
          </template> -->
          <DxColumn type="buttons" :width="110">
            <DxButtonDataGrid name="edit" />
            <DxButtonDataGrid name="delete" />
            <DxButtonDataGrid
              hint="View Log Perubahan"
              icon="clock"
              :visible="true"
              @click="this.$refs.logPopup.showBySubject($event, 'Pengajuan')"
            />
          </DxColumn>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import { API_BASE_URL } from "@/global-constants";
import { DxFileUploader } from "devextreme-vue/file-uploader";
import { useNaikPangkatListStore } from "@/stores/views/naik-pangkat-list-store";
import { DxSelectBox } from "devextreme-vue/select-box";
import notify from "devextreme/ui/notify";
import { usePegawaiListStore } from "@/stores/views/pegawai-list-store";
import auth from "../auth";
import * as commonFunction from "@/utils/common-function.js";
import { BASE_URL } from "@/global-constants";
import StatusPengajuanTemplate from "./StatusPengajuanTemplate.vue";
import { usePengajuanListStore } from "@/stores/views/pengajuan-list-store";
import { useCommonStore } from "@/stores/utility/common-store2";
import { confirm } from "devextreme/ui/dialog";
import can from "@/haspermission";

import DxButton from "devextreme-vue/button";
import { DateTime } from "luxon";
import _ from "lodash";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
  DxButton as DxButtonDatagrid,
  DxSummary,
  DxTotalItem,
  DxHeaderFilter,
  DxRequiredRule,
  DxSelection,
  DxButton as DxButtonDataGrid,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";
import api from "@/api";
import axios from "axios";
import LogPopupTemplate from "./LogPopupTemplate.vue";
/* eslint-disable */
export default {
  components: {
    LogPopupTemplate,
    confirm,
    DxTextBox,
    DxDateBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxButton,
    DxButtonDatagrid,

    DxPopup,
    DxToolbarItem,
    DxItem,
    DxDropDownButton,

    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
    StatusPengajuanTemplate,
    DxRequiredRule,
    DxSelectBox,
    DxSelection,
    DxFileUploader,
    DxButtonDataGrid,
  },
  setup() {
    const pengajuanListStore = usePengajuanListStore();
    const commonStore = useCommonStore();
    const pegawaiListStore = usePegawaiListStore();
    const naikPangkatListStore = useNaikPangkatListStore();
    return {
      pengajuanListStore,
      commonStore,
      commonFunction,
      pegawaiListStore,
      naikPangkatListStore,
    };
  },
  data() {
    const vm = this;
    return {
      logPopupRef: null,
      selectedPegawaiId: null,
      dxEditingMode: "popup", //row
      serverUrl: `${BASE_URL}/`,
      fileUrl: null,
      stylingMode: "filled",
      //outlined, filled, underlined
      labelMode: "floating",

      numberingPageSize: 100,
      buttonFilterPintasanVisible: false,
      pegawaiSource: [{ id: null, display_expr: null }],
      selectedRows: [],
      tipeNaikPangkatStore: null,
      golonganStore: null,
      loadingVisible: false,
    };
  },

  async created() {
    let filter = null;
    if (!_.isNil(this.$route.query.filter)) {
      filter = this.$route.query.filter;
    }
    this.pengajuanListStore.dataSourcePengajuanList.filter(filter);
    await this.commonStore.preloadStores();
  },

  async mounted() {
    let tempA = await this.pegawaiListStore.dataSourcePegawaiListCoba(null, [
      {
        selector: "simpeg_pegawais.nama",
        desc: false,
      },
    ]);

    this.pegawaiSource = tempA.data; //all pegawai

    this.tipeNaikPangkatStore = this.commonStore.tipeNaikPangkatStore;
    // this.tipeNaikPangkatStore.unshift({ id: null, nama: null });
    // if (
    //   !this.tipeNaikPangkatStore.some(
    //     (item) => item.id === null && item.nama === null
    //   )
    // ) {
    //   this.tipeNaikPangkatStore.unshift({ id: null, nama: null });
    // }

    this.golonganStore = this.commonStore.golonganStore;
    if (
      !this.golonganStore.some((item) => item.id === null && item.nama === null)
    ) {
      this.golonganStore.unshift({ id: null, nama: null });
    }
  },

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  methods: {
    async onSaved() {
      if (!this.file) return;
      const formData = new FormData();
      formData.append("fileName", this.fileName);
      formData.append("file", this.file);

      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "multipart/form-data",
        },
      };
      axios
        .post(`${API_BASE_URL}/arsip/upload_store`, formData, config)
        .then((response) => {
          notify(response.data.message, response.data.notify_type);
          this.file = null;
          this.fileName = null;
          this.filePath = null;
        })
        .catch((error) => {
          this.file = null;
          this.fileName = null;
          this.filePath = null;
          console.error(error);
          notify("Gagal upload file", "error");
        });
    },

    async handlePegawaiChange(e, cellInfo) {
      this.selectedPegawaiId = e.value;
      cellInfo.setValue(e.value);
      const selectedPegawai = this.pegawaiSource.find(
        (pegawai) => pegawai.id === this.selectedPegawaiId,
      );
      const tglMulaiBekerja = selectedPegawai
        ? selectedPegawai.tgl_mulai_bekerja
        : null;
      let tglBaru = cellInfo.component.cellValue(cellInfo.rowIndex, "tgl");
      let golBaru = cellInfo.component.cellValue(
        cellInfo.rowIndex,
        "golongan_id",
      );
      let capeg = cellInfo.component.cellValue(cellInfo.rowIndex, "capeg");
      let jenisBaru = cellInfo.component.cellValue(cellInfo.rowIndex, "jenis");
      cellInfo.component.cellValue(cellInfo.rowIndex, "masa_kerja", null);
      cellInfo.component.cellValue(cellInfo.rowIndex, "masa_kerja_bulan", null);

      let masaKerja = null;
      if (jenisBaru === "KP") {
        masaKerja = await this.hitungMasaKerjaNaikPangkat(
          tglBaru,
          tglMulaiBekerja,
          golBaru,
          capeg,
        ); //pass tgl,
      } else if (jenisBaru === "KGB") {
        masaKerja = await this.hitungMasaKerjaKgb(tglBaru, tglMulaiBekerja);
      }

      cellInfo.component.cellValue(
        cellInfo.rowIndex,
        "masa_kerja",
        masaKerja.years,
      );
      cellInfo.component.cellValue(
        cellInfo.rowIndex,
        "masa_kerja_bulan",
        masaKerja.months,
      );
      cellInfo.component.cellValue(
        cellInfo.rowIndex,
        "pegawai_id",
        this.selectedPegawaiId,
      );

      // console.log(
      //   "handlePegawaiChange tglBaru",
      //   tglBaru,
      //   "golBaru",
      //   golBaru,
      //   "jenisBaru",
      //   jenisBaru
      // );
    },

    hitungMasaKerja(tgl, tglMulaiBekerja) {
      tglMulaiBekerja = DateTime.fromISO(tglMulaiBekerja).set({ day: 1 });

      tgl = DateTime.fromJSDate(new Date(tgl)).set({ day: 1 });

      const diff = tgl.diff(tglMulaiBekerja, ["years", "months"]);

      const years = Math.floor(diff.years); // Get full years
      const months = Math.floor(diff.months); // Get full months

      return { years: years, months: months };
    },

    onEditorPreparing(e) {
      if (
        e.name === "tgl" ||
        e.name === "golongan_id" ||
        e.name === "jenis" ||
        e.name === "capeg"
      ) {
        e.editorOptions.onValueChanged = async (args) => {
          const selectedPegawai = this.pegawaiSource.find(
            (pegawai) => pegawai.id === this.selectedPegawaiId,
          );
          const tglMulaiBekerja = selectedPegawai
            ? selectedPegawai.tgl_mulai_bekerja
            : null;

          console.log("oneditorpreparing tglMulaiBekerja", tglMulaiBekerja);
          e.component.cellValue(e.row.rowIndex, "masa_kerja", null);
          e.component.cellValue(e.row.rowIndex, "masa_kerja_bulan", null);
          if (!args.value) {
            e.setValue(args.value);
            e.component.cellValue(e.row.rowIndex, e.name, args.value);
            return;
          }

          let tglBaru =
            e.name === "tgl"
              ? args.value
              : e.component.cellValue(e.row.rowIndex, "tgl");

          // Determine the new golongan_id value based on the event name
          let golBaru =
            e.name === "golongan_id"
              ? args.value
              : e.component.cellValue(e.row.rowIndex, "golongan_id");

          let capeg =
            e.name === "capeg"
              ? args.value
              : e.component.cellValue(e.row.rowIndex, "capeg");

          // Determine the new jenis_naik_pangkat value based on the event name
          let jenisBaru =
            e.name === "jenis"
              ? args.value
              : e.component.cellValue(e.row.rowIndex, "jenis");

          console.log(
            "oneditorpreparing onValueChanged tglBaru",
            tglBaru,
            "golBaru",
            golBaru,
            "jenisBaru",
            jenisBaru,
          );
          let masaKerja = null;
          if (jenisBaru === "KP") {
            masaKerja = await this.hitungMasaKerjaNaikPangkat(
              tglBaru,
              tglMulaiBekerja,
              golBaru,
              capeg,
            ); //pass tgl,
          } else if (jenisBaru === "KGB") {
            masaKerja = await this.hitungMasaKerjaKgb(tglBaru, tglMulaiBekerja);
          }

          if (!masaKerja) masaKerja = { years: 0, months: 0 };
          e.component.cellValue(e.row.rowIndex, "masa_kerja", masaKerja.years);
          e.component.cellValue(
            e.row.rowIndex,
            "masa_kerja_bulan",
            masaKerja.months,
          );

          e.setValue(args.value);
          // e.component.cellValue(e.row.rowIndex, "tgl", args.value);
          e.component.cellValue(e.row.rowIndex, e.name, args.value);
        };
      }
    },
    async hitungMasaKerjaNaikPangkat(
      tgl,
      tglMulaiBekerja,
      golonganId,
      capeg = false,
    ) {
      let masaKerja = this.hitungMasaKerja(tgl, tglMulaiBekerja);
      if (capeg) masaKerja.years = 1; // jika capeg, masa kerja 1 tahun
      else {
        masaKerja.years = masaKerja.years - 2;
        if (golonganId > 8) {
          masaKerja.years = masaKerja.years - 5;
        }
      }
      return masaKerja;
    },

    async hitungMasaKerjaKgb(tgl, tglMulaiBekerja) {
      let masaKerja = this.hitungMasaKerja(tgl, tglMulaiBekerja);
      let tglNaikPangkatC1 = null;
      const naikPangkatC1 = await this.getAllDataNaikPangkat();

      if (naikPangkatC1.length > 0) {
        tglNaikPangkatC1 = _.minBy(
          naikPangkatC1,
          (item) => new Date(item.tgl),
        ).tgl;
      }
      if (tglNaikPangkatC1) {
        if (
          DateTime.fromJSDate(new Date(tgl)) >=
          DateTime.fromISO(tglNaikPangkatC1)
        )
          // .set({ day: 1 }) perlukah untuk argsvalue and tglnaikpangkatc1?
          masaKerja.years = masaKerja.years - 5;
      }
      console.log("hitungMasaKerjaKgb mk", masaKerja);
      masaKerja.years = masaKerja.years - 2;
      return masaKerja;
    },

    async getAllDataNaikPangkat() {
      let filter = [
        ["pegawai_id", "=", this.selectedPegawaiId],
        "and",
        ["golongans_id", ">", 8],
      ];
      return await this.naikPangkatListStore.loadData(filter);
    },

    getPegawaiId(data) {
      console.log("getPegawaiId", data);
      if (data.value === undefined) {
        return null; //insert
      }
      return data.data.pegawai_id;
    },
    showData(data) {
      console.log("showData", data);
      // return data.simpeg_pegawais_nama;
    },
    onContextMenuPreparing(e) {
      console.log("onContextMenuPreparing", e);
      if (e.target == "content") {
        e.element.id = e.row.data.pegawai_id;
        const data = {}; // Declare a constant object
        data.pegawai_id = e.row.data.pegawai_id;

        // e.items can be undefined
        if (e.row.isEditing) return;
        if (!e.items) e.items = [];

        if (
          this.allowUpdate(this.can("pegawai-update"), this.can("gaji-approve"))
        ) {
          e.items.push({
            text: "Edit Pengajuan",
            icon: "edit",

            onItemClick: () => {
              e.component.editRow(e.rowIndex);
            },
          });
        }

        e.items.push({
          text: "Lihat Detail Pegawai",
          icon: "user",
          beginGroup: true,
          onItemClick: () => {
            e.itemData = "Detail Pegawai";
            this.onItemClick(e, data);
          },
        });

        e.items.push({
          text: "Lihat Absensi",
          icon: "event",
          onItemClick: () => {
            e.itemData = "Absensi";
            this.onItemClick(e, data);
          },
        });

        e.items.push({
          text: "Riwayat Gaji",
          icon: "money",
          onItemClick: () => {
            e.itemData = "Riwayat Gaji";
            this.onItemClick(e, data);
          },
        });

        e.items.push({
          text: "Log Perubahan Data",
          icon: "clock",
          onItemClick: () => {
            e.itemData = "Log Perubahan Data";
            this.$refs.logPopup.showBySubject(e.row.key, "Pengajuan");
          },
        });
      }
    },

    templateCreatedByUser(cellElement, cellInfo) {
      cellElement.innerText = this.commonFunction.viewCreatedByUser(
        cellInfo.data,
      );
      // return
    },

    async onUpdating(e) {
      console.log("test onUpdating e", e);
      let jenis = e.oldData.jenis;
      if (!_.isNil(e.newData.jenis)) {
        jenis = e.newData.jenis;
      } //jenis pengajuan mengikuti perubahan data yang terbaru

      if (jenis === "KP") {
        if (
          !this.validasiNaikPangkatUpdate(
            e.oldData,
            e.newData,
            "golongan_id",
          ) ||
          !this.validasiNaikPangkatUpdate(
            e.oldData,
            e.newData,
            "jenis_naik_pangkat",
          )
        ) {
          e.cancel = true;
          notify("Salah input Golongan dan Jenis Naik Pangkat", "error");
        }
      }

      if (jenis === "KGB") {
        e.newData.golongan_id = null;
        e.newData.jenis_naik_pangkat = null;
        console.log(
          "test KGB UBAH GOLONGAN N JENISNAIKPANGKAT",
          e.newData.golongan_id,
          e.newData.jenis_naik_pangkat,
        );
      }

      if (e.newData.status > 0 && e.oldData.status != e.newData.status) {
        e.newData.approved_by_user_id = auth.getUser().id;
        e.newData.approved_at = DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss");
      } else {
        e.newData.updated_by_user_id = auth.getUser().id;
      }
    },

    validasiNaikPangkatUpdate(lama, baru, kolom) {
      let jenis = lama.jenis;
      if (!_.isNil(baru.jenis)) {
        jenis = baru.jenis;
      } //jenis pengajuan mengikuti perubahan data yang terbaru

      if (
        !_.isNil(baru.jenis) &&
        baru.jenis === "KP" &&
        _.isUndefined(baru[kolom])
      ) {
        //perubahan dari kgb ke kp dan tidak melakukan perubahan golongan/jenisnaikpangkat
        return false;
      }
      if (_.isNull(baru[kolom])) {
        // golongan_id is undefined
        return false;
      }

      return true;
    },

    validasiNaikPangkatUpdate2(lama, baru, kolom) {
      let jenis = lama.jenis;
      if (!_.isNil(baru.jenis)) {
        jenis = baru.jenis;
        if (jenis === "KP") {
          if (_.isNil(baru[kolom])) {
            console.log("test tidak boleh diupdate KP 3");
            return false;
          }
        }
      } //jenis pengajuan mengikuti perubahan data yang terbaru

      console.log("test " + kolom + " JENIS", jenis);
      console.log("test " + kolom + " LAMA", lama[kolom], _.isNil(lama[kolom]));
      console.log("test " + kolom + " BARU", baru[kolom], _.isNil(baru[kolom]));

      if (jenis === "KP" && _.isNil(lama[kolom]) && _.isNil(baru[kolom])) {
        //nil = null or undefined
        console.log("test tidak boleh diupdate KP 1");
        return false;
      } else if (
        jenis === "KP" &&
        !_.isNil(lama[kolom]) &&
        _.isNil(baru[kolom])
      ) {
        console.log("test tidak boleh diupdate KP 2");
        return false;
      }

      if (jenis === "KGB" && _.isNil(lama[kolom]) && _.isNil(baru[kolom])) {
        //nil = null or undefined
        console.log("test tidak boleh diupdate KGB 1");
        return false;
      } else if (
        jenis === "KGB" &&
        !_.isNil(lama[kolom]) &&
        !_.isNil(baru[kolom])
      ) {
        console.log("test tidak boleh diupdate KGB 2");
        return false;
      }
      console.log("test BOLEH UPDATE");
      return true;
    },

    validasiNaikPangkat(data, kolom) {
      if (data.jenis === "KP" && (!data[kolom] || data[kolom] === null)) {
        console.log("test golongan tidak boleh diinsert KP");
        return false;
      } else if (data.jenis === "KGB" && data[kolom] && data[kolom] !== null) {
        console.log("test golongan tidak boleh diinsert KGB");
        return false;
      } else {
        console.log("test bisa insert golongan");
        return true;
      }
    },

    async onInserting(e) {
      if (e.data.simpeg_pegawais_nama) {
        e.data.pegawai_id = e.data.simpeg_pegawais_nama;
        delete e.data.simpeg_pegawais_nama;
      }
      console.log("test onInserting e", e);
      if (
        this.validasiNaikPangkat(e.data, "golongan_id") &&
        this.validasiNaikPangkat(e.data, "jenis_naik_pangkat")
      ) {
        if (e.data.status > 0) {
          e.data.approved_by_user_id = auth.getUser().id;
          e.data.approved_at = DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss");
        }
        e.cancel = false;
      } else {
        e.cancel = true;
        notify("Salah input Golongan dan Jenis Naik Pangkat", "error");
      }
    },
    async onSaving(e) {
      console.log("test onSaving e", e);
      e.cancel = true;
      return;
      if (e.changes.length > 0) {
        const data = e.changes[0].data;
        const key = e.changes[0].key;
        const type = e.changes[0].type;
        // const rowData = await e.component.getDataByKeys(e.changes[0].key);
        console.log("onSaving data", data);
        if (type == "update" && data.jenis === "KP") {
          const visibleRows = e.component.getVisibleRows();
          const targetRow = _.find(visibleRows, { key: key }).data;
          console.log("onSaving targetRow", targetRow);
        } else {
          //insert
        }
      }
      return;

      if (data.jenis === "KP") {
        //check if golongan_id and jenis_naik_pangkat is empty
        if (!data.golongan_id || !data.jenis_naik_pangkat) {
          notify("Golongan dan Jenis Naik Pangkat harus diisi", "error");
          e.cancel = true;
        }
      }
    },
    onSelectRowsConfirm(status) {
      let result = confirm(
        "<strong>Yakin mengubah status pengajuan?</strong> <br> Data yang sudah disetujui atau ditolak tidak dapat diubah lagi",
        "Konfirmasi Status Pengajuan",
      );
      result.then((dialogResult) => {
        if (dialogResult) {
          this.onSelectRows(status);
        }
      });
    },
    async onSelectRows(status) {
      //1 = setujui, 2 = tolak

      try {
        const dataGrid = this.$refs.dataGrid.instance;
        const selectedRows = await dataGrid.getSelectedRowsData();
        const filteredRows = selectedRows.filter((row) => row.status <= 0);
        const updatedRows = filteredRows.map((row) => ({
          ...row, // Spread the original row properties
          status: status, // Update the status to the provided value
          updated_by_user_id: auth.getUser().id,
          approved_by_user_id: auth.getUser().id,
          approved_at: DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss"),
        }));

        console.log("Selected Row Keys ONSELECTROWS filter:", filteredRows);
        console.log("Selected Row Keys ONSELECTROWS updatedRows:", updatedRows);
        if (_.isEmpty(updatedRows)) {
          notify("Tidak ada data yang dapat diubah", "error");
          return;
        }
        // Call updateData method with updatedRows
        this.loadingVisible = true;
        const result = await this.pengajuanListStore.updateData(updatedRows);
        if (result) {
          notify("Berhasil mengubah status pengajuan", "success");
          this.refreshDatagrid("dataGrid");
        }
        console.log("debug onSelectRows result", result);
        this.loadingVisible = false;
      } catch (error) {
        console.error("Error in onSelectRows:", error);
        this.loadingVisible = false;
        notify("Gagal mengubah status pengajuan " + error, "error");
      }
    },

    onRowRemoving(e) {
      console.log("onRowRemoving e", e);
      if (e.data.status > 0) {
        e.cancel = true;
        notify(
          "Tidak dapat menghapus data yang sudah disetujui atau ditolak",
          "error",
        );
      }
    },
    onEditingStart(e) {
      this.selectedPegawaiId = e.data.pegawai_id;
      console.log("onEditingStart selectedpegawaiid", this.selectedPegawaiId);
      if (e.data.status > 0) {
        e.cancel = true;
        notify(
          "Tidak dapat mengedit data yang sudah disetujui atau ditolak",
          "error",
        );
      }
    },

    allowUpdate(a, b) {
      if (a || b) return true;
      else return false;
    },
    initNewRow(e) {
      e.data.created_by_user_id = auth.getUser().id;
      e.data.status = 0;
      this.selectedPegawaiId = null;
      console.log("initNewRow selectedpegawaiid", this.selectedPegawaiId);
    },
    displayCapeg(e) {
      if (e.value) {
        return "80%";
      }
    },
    setPrintAdaFile(e) {
      console.log("setPrintAdaFile ", e);
      if (_.isEmpty(e)) return false;
      else return true;
    },

    hilangFilter() {
      // this.absenStore.onMuatButtonClick();
      this.buttonFilterPintasanVisible = false;
    },
    onItemClick(e, data) {
      console.log("onItemClick e", e);
      console.log("onItemClick data", data);
      let pegawaiId = data.pegawai_id;

      if (e.itemData === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: { filter: ["absen_bulans_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "pegawai-detail-custom",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Log Perubahan Data") {
        this.$refs.logPopup.showBySubject(data.id, "Pengajuan");
      }
    },

    can,

    refreshDatagrid(gridRef) {
      this.pengajuanListStore.dataSourcePengajuanList.filter(null);
      // this.$refs[gridRef].instance.clearFilter();
      this.$refs[gridRef].instance.getDataSource().reload();
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Absen");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Pengajuan.xlsx",
          );
        });
      });
      e.cancel = true;
    },

    async downloadFile() {
      if (this.fileUrl === null || this.fileUrl === "") {
        notify("File tidak ada", "error");
        return;
      }

      try {
        const response = await api.post(
          `${API_BASE_URL}/arsip/download`,
          { file_path: this.fileUrl },
          {
            responseType: "blob",
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
            },
          },
        );
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        // Extract file extension from Content-Disposition header
        const contentDisposition = response.headers["content-disposition"];
        const urlParts = this.fileUrl.split(".");
        const extension =
          urlParts.length > 1 ? urlParts[urlParts.length - 1] : "";
        let filename =
          "Arsip Pegawai - " +
          this.dataSourcePegawai.nama +
          " - " +
          this.fileTitle +
          " - " +
          this.fileTableId +
          "." +
          extension;

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) {
            filename = match[1];
          }
        }

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);

        // Append the link to the body (required for Firefox)
        document.body.appendChild(link);

        // Trigger the download
        link.click();

        // Cleanup
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } catch (error) {
        console.error(error);
        notify("Dokumen gagal didownload.", "error");
      }

      return;
    },
    handleClickDocument(e, title) {
      if (e.data.file_path !== null) {
        this.fileUrl = e.data.file_path;
        if (title === "File Arsip") {
          title =
            title + " - " + e.data.arsip_kategoris_nama + " - " + e.data.nama;
        }

        this.fileTitle = title;
        this.fileTableId = e.data.id;
        this.downloadFile();
      }
    },

    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        },
      );
    },

    onFileValueChanged(e, cellInfo) {
      const uploadButton = e.element.querySelector(
        ".dx-fileuploader-upload-button",
      );
      const fileContainer = e.element.querySelector(
        ".dx-fileuploader-files-container",
      );
      if (uploadButton) {
        uploadButton.style.display = "none"; // Hide the upload button
      }
      if (fileContainer) {
        fileContainer.style.display = "block"; // Hide the file container
      }

      if (e.value && e.value[0]) {
        const fileNameTemp = e.value[0].name;
        const fileExtension = fileNameTemp.substring(
          fileNameTemp.lastIndexOf(".") + 1,
        );
        this.file = e.value[0];
        console.log("onFileValueChanged file", this.file);
        var guid = this.uuidv4();
        this.fileName = guid + "." + fileExtension;
        this.filePath = "files/" + this.fileName;
        cellInfo.data.setValue(this.filePath);
      }
    },
  },
};
</script>
